module.exports = __webpack_public_path__ + "static/media/MC1.a8e83917.jpeg";